import { gql, useLazyQuery, useQuery } from '@apollo/client';

import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

const schemaFromHashQuery = gql`
  query SchemaFromHashQuery($graphId: ID!, $schemaHash: SHA256) {
    service(id: $graphId) {
      id
      doc(hash: $schemaHash) {
        source
      }
    }
  }
`;

export const useSchemaFromHash = ({
  graphId,
  schemaHash,
  skip,
}: {
  graphId: string;
  schemaHash?: string;
  skip?: boolean;
}) => {
  return useQuery<
    GraphQLTypes.SchemaFromHashQuery,
    GraphQLTypes.SchemaFromHashQueryVariables
  >(schemaFromHashQuery, {
    context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
    variables: {
      graphId,
      schemaHash,
    },
    skip: graphId === undefined || skip,
  });
};

export const useLazySchemaFromHash = () => {
  const [getSchema] = useLazyQuery<
    GraphQLTypes.SchemaFromHashQuery,
    GraphQLTypes.SchemaFromHashQueryVariables
  >(schemaFromHashQuery);

  return { getLazySchemaFromHash: getSchema };
};
